import {http} from "../../Services/Http/HttpClient";

export interface UpdateEnrollmentRequest{
    name: string;
    price: number;
    enabled: boolean;
    activitySessions: string[];
}

export const updateEnrollment = async (id: string, data: UpdateEnrollmentRequest) => {
    return await http.patch('/enrollments/' + id, data)
}

export const createEnrollment = async (data: UpdateEnrollmentRequest) => {
    return await http.post('/enrollments', data)
}
